<template>
  <div class="w-100">
    <div class="d-flex">
      <div class="w-100 card text-start p-3 mb-3">
        <div class="d-flex justify-content-between">
          <div class="mt-2 col-lg-8 text-uppercase">
            <div class="fw-bold d-flex" v-if="this.id != 'add'">
              <p v-if="!this.editName">
                {{ name }}
              </p>
              <div class="col-md-3 me-2 mb-1" v-else>
                <input type="text" class="form-control" v-model="name" maxLength="32" />
              </div>
              <span class="ms-2" @click="editName=true">
                <font-awesome-icon icon="fa-solid fa-pencil" />
              </span>
            </div>
            <div class="d-flex align-items-center" v-else>
              <div class="col-md-3">
                <label class="pe-3"> Category Promo Name </label>
              </div>
              <div class="col-md-5">
                <input type="text" class="form-control" v-model="name" maxLength="32" />
              </div>
            </div>
          </div>
          <div class="col-lg-5 d-flex align-items-center">
            <div class="col-md-3">
              <label class="pe-3"> Start Date </label>
            </div>
            <div class="col-md-9">
              <DatePicker placeholder="Date Start" textInput v-model="startDate" style="width: 70%"
                :format="'MM/dd/yyyy'" :enable-time-picker=false />
            </div>
          </div>
        </div>
        <div class="d-flex mt-2">
          <div class="fw-bold col-md-4" v-if="this.id != 'add'">
            <p>
              Created By :
              {{ categoryPromo ? categoryPromo.created_by_name : "" }} -
              {{ categoryPromo ? categoryPromo.created_date : "" }}
            </p>
          </div>
          <div class="d-flex align-items-center col-md-8" v-else></div>
          <div class="fw-bold col-md-4" v-if="this.id != 'add'">
            Products Count :
            {{ categoryPromo ? categoryPromo.product_count : 0 }}
          </div>
          <div class="col-lg-5 d-flex align-items-center">
            <div class="col-md-3">
              <label class="pe-3"> End Date </label>
            </div>
            <div class="col-md-9">
              <DatePicker placeholder="Date End" textInput v-model="endDate" style="width: 70%"
                :format="'MM/dd/yyyy'" />
            </div>
          </div>
        </div>
        <div class="alert alert-warning mt-3 mb-0" role="alert" style="padding: 0.7rem 0.7rem;" v-if="showAlertDate">
          <font-awesome-icon icon="fa-solid fa-circle-info" class="me-1 text-warning" /> {{alertMessage}}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="w-100 card text-start p-3 mb-3">
        <div class="row">
          <div class="col-md-3">Badge Title</div>
          <div class="col-md-3">Badge Icon</div>
          <div class="col-md-3">Badge Background Color</div>
          <div class="col-md-3">Badge Preview</div>
        </div>
        <div class="row mt-3">
          <div class="col-md-3">
            <input type="text" class="form-control" v-model="badge_title" maxlength="30" />
          </div>
          <div class="col-md-3">
            <div class="file-input btn btn-light rounded" v-if="!urlBadge">
              <input type="file" id="file" class="file" accept="image/*" @change="readURL" />
              <label for="file">
                <font-awesome-icon icon="fa-solid fa-plus" style="color: #5e50a1" /></label>
            </div>
            <div v-else>
              <div class="file-input btn btn-light rounded">
                <input type="file" id="file" class="file" accept="image/*" @change="readURL" />
                <label for="file">
                  <img v-if="urlBadge" :src="urlBadge" id="myImg" />
                </label>
              </div>
              <span class="ms-3" @click="removeBadge">
                <font-awesome-icon icon="fa-solid fa-trash" />
              </span>
            </div>

          </div>
          <div class="col-md-3 d-flex">
            <input type="text" class="form-control rounded w-10" :style="
                badge_color != ''
                  ? `background: ${badge_color}; color: white`
                  : `background: #FFFFFF ; color: white`
              " disabled />
            <input type="text" class="form-control w-75" v-model="badge_color" />
          </div>
          <div class="col-md-3">
            <div class="d-flex form-control rounded p-2 w-75" style="height: 30px" :style="
                badge_color != ''
                  ? `background: ${badge_color}; color: white`
                  : `background: #FFFFFF ; color: white`
              ">
              <img v-if="urlBadge" :src="urlBadge" />
              <p class="fw-bold text-uppercase ms-2">{{ badge_title }}</p>
            </div>
          </div>
        </div>
        <div class="alert alert-warning mt-3 mb-0" role="alert" style="padding: 0.7rem 0.7rem;" v-if="showAlert">
          <font-awesome-icon icon="fa-solid fa-circle-info" class="me-1 text-warning" /> {{alertMessage}}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="w-100 card text-start p-3 mb-3">
        <div class="row">
          <div class="col-lg-10">
            <input type="text" class="form-control" v-model="searchSuggestion"
              placeholder="Search by Product ID or Name" />
            <div ref="scrollable" class="list-group list-group-flush autocomplete-form-items border rounded" v-show="visible">
              <div v-for="(val, index) in displayedSuggestions" :key="index" :data-id="index"
                class="list-group-item list-group-item-action" :class="{ isActive: pickedSuggestions.find(x => x.id == val.id) }"
                @click="onClickHandler($event, val)">
                <div class="d-flex">
                  <div class="d-flex flex-fill align-items-center">
                    <div
                      class="me-auto d-flex"
                    >
                      <ImageCustom
                        :src="val.image_url"
                        :width="36" 
                        :height="36" 
                        className="rounded me-3" 
                      />
                      <div class="d-flex flex-column">
                        <span>{{ val.name }}</span>
                        <span>by <strong>{{ val?.seller?.store_name }}</strong></span>
                      </div>
                    </div>
                    <span v-if="val.is_variant">{{ val.price_displayed }}</span>
                    <template v-else>
                      <div v-if="val.price_regular > val.price_sale" class="d-flex text-capitalize">
                        <span class="text-muted me-2" style="text-decoration: line-through">
                          {{ filters.rupiah(val.price_regular) }}
                        </span>
                        <span>{{ filters.rupiah(val.price_sale) }}</span>
                      </div>
                      <span v-else class="text-capitalize">{{ filters.rupiah(val.price_regular) }}</span>
                    </template>
                  </div>
                  <!-- Display Active Checkbox -->
                  <input 
                    v-if="pickedSuggestions.find(x => x.id == val.id)"
                    class="form-check-input mt-0 ms-3 align-self-center" 
                    type="checkbox"
                    checked
                    @click="(e)=>e.preventDefault()"
                    />
                  <!-- Display non-Active Checkbox -->
                  <input 
                    v-else
                    class="form-check-input mt-0 ms-3 align-self-center" 
                    type="checkbox"
                    @click="(e)=>e.preventDefault()"
                    />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-danger text-white shadow-sm rounded p-2 text-uppercase rounded w-100"
              @click="addProduct">
              + ADD PRODUCT
            </button>
          </div>
        </div>
      </div>
    </div>
    <TableBasic :payload="payload" @onChange="changeParameter" :pageChangeScrollUp="false">
      <template v-slot:action="{ value }">
        <div>
          <button class="btn" :class="value.delete == 'disable' ? 'disabled' : ''" @click="deleteProduct(value.id)">
            <font-awesome-icon icon="fa-solid fa-trash" class="text-danger" />
          </button>
        </div>
      </template>
      <template v-slot:id="{ value }">
        <div class="d-flex">
          <router-link
            :to="'/products/detail/'+value"
            class="text-decoration-none fw-bold"
            style="color: #5e50a1"
          >
            {{ value }}
          </router-link>
        </div>
      </template>
      <template v-slot:name="{ data, value }">
        <div class="d-flex">
          <ImageCustom
            :src="data.image_url"
            :width="36" 
            :height="36" 
            className="rounded me-3" 
          />
          <router-link
            :to="'/products/detail/'+data.id"
            class="text-decoration-none fw-bold mt-3"
            style="color: #5e50a1"
          >
            {{ value }}
          </router-link>
        </div>
      </template>
      <template v-slot:price_regular="{ data, value }">
        <span v-if="data.is_variant" class="text-capitalize">{{ data.price_displayed }}</span>
        <template v-else>
          <div v-if="value > data.price_sale" class="d-flex text-capitalize">
            <span class="text-muted me-2" style="text-decoration: line-through">
              {{ filters.rupiah(value) }}
            </span>
            <span>{{ filters.rupiah(data.price_sale) }}</span>
          </div>
          <span v-else class="text-capitalize">{{ filters.rupiah(value) }}</span>
        </template>
      </template>
    </TableBasic>
    <div class="text-start mb-3">
      <button type="button"
        class="btn btn-link shadow-sm rounded p-2 text-uppercase rounded text-danger border border-danger text-decoration-none"
        @click="discard">
        DISCARD
      </button>
      <button type="button" class="btn btn-danger text-white shadow-sm rounded p-2 text-uppercase rounded ms-3"
        @click="submit" :disabled="name == '' || (products.length == 0 && payload.value.length == 0)">
        UPDATE CATEGORY PROMO
      </button>
    </div>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  import DatePicker from "@vuepic/vue-datepicker";
  import "@vuepic/vue-datepicker/dist/main.css";
  import moment from "moment";
  import lodash from "lodash"
  import ImageCustom from "@/components/Image.vue";

  export default {
    components: {
      TableBasic,
      DatePicker,
      ImageCustom
    },
    watch: {
      'payload.currentPage': function (val, oldVal) {
        if (val !== oldVal) {
        this.handleGetProductPagination()
        }
      },
      'payload.perPage': function (val, oldVal) {
        if (val !== oldVal) {
        this.handleGetProductPagination()
        }
      },
      sortType(val){
        if(val){
          if (this.id != "add"){
            this.getProduct()
          }else{
            this.handleLocalSort()
          }
        }
      },
      deleteItems() {
        this.handleDeleteAll()
      },
      badge_color(value) {
        const validSix = /^#[0-9A-F]{6}$/i.test(value)
        const validTree = /^#([0-9A-F]{3}){1,2}$/i.test(value)
        if (!validSix && !validTree) {
          this.showAlert = true
          this.alertMessage = "Color Badge icon invalid Hex Code"
        }

        setTimeout(() => {
          this.showAlert = false
        }, 3000);
      },
      badge_title(value) {
        if (value.length > 30) {
          this.showAlert = true
          this.alertMessage = "Badge title max length more than 30 characters"
        }

        setTimeout(() => {
          this.showAlert = false
        }, 3000);
      },
      searchSuggestion: lodash.debounce(function(val) {
        if(val){
          this.visible = true
        }
        if(!val && !this.displayedSuggestions.length){
          this.visible = false
        }
        this.pageSuggestion = 1
        this.productSearch();
      }, 1000),
      displayedSuggestions(val){
        if(!val.length){
          this.visible = false
        }
      },
      searchProduct() {
        if (this.id != "add"){
          this.getProduct()
        }else{
          this.handleLocalSearch();
        }
      },
      startDate(value) {
        if (value > this.endDate && this.endDate != "") {
          this.showAlertDate = true
          this.alertMessage = "From date should not be greater than To date"
        }

        setTimeout(() => {
          this.showAlertDate = false
        }, 3000);
      },
      endDate(value) {
        if (value < this.startDate && this.startDate != "") {
          this.showAlertDate = true
          this.alertMessage = "From date should not be greater than To date"
        }

        setTimeout(() => {
          this.showAlertDate = false
        }, 3000);
      }
    },
    created() {
      var currentUrl = this.$route.path.split("/");
      this.id = currentUrl[currentUrl.length - 1];
    },
    data() {
      return {
        searchSuggestion: "",
        sizeSuggestion: 10,
        pageSuggestion: 1,
        suggestionCount: 0,
        searchProduct: "",
        name: "",
        id: "",
        badge_color: "",
        badge_title: "",
        datepickerOption: {},
        payload: {
          header: [{
              key: "id",
              label: "Product ID",
              class: "text-start text-uppercase",
            },
            {
              key: "name",
              label: "Product Name",
              class: "text-start text-uppercase",
            },
            {
              key: "price_regular",
              label: "Price",
              class: "text-start text-uppercase",
            },
            {
              key: "stock_current",
              label: "Stock",
              class: "text-start text-uppercase",
              sort: true,
              sort_key: "stock_current"
            },
            {
              key: "status",
              label: "Product Status",
              class: "text-start text-uppercase",
              sort: true,
              sort_key: "product_status"
            },
            {
              key: "action",
              label: "Actions",
              class: "text-start text-uppercase",
            },
          ],
          value: [],
          checkbox: true,
          filter: false,
          search: true,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 25, 50, 100],
          searchPlaceholder: "Search by Product ID and Product Name",
          totalItems: 0,
          deleteProductRow: true
        },
        sortBy: "",
        sortType: 0,
        products: [],
        selectedFiles: undefined,
        urlBadge: "",
        categoryPromo: {},
        startDate: "",
        endDate: "",
        visible: false,
        suggestionValues: [],
        pickedSuggestions: [],
        selectedIndex: 0,
        showAlert: false,
        showAlertDate: false,
        alertMessage: "",
        width: 0,
        height: 0,
        editName: false,
        addProductIds: [],
        removePoductIds: [],
        productLocal : [],
        deleteItems: false,
        pickItems: [],
        badgeErrorList : [],
      };
    },
    computed: {
      displayedSuggestions(){
        return lodash.uniqBy([...this.pickedSuggestions,...this.suggestionValues], "id")
      }
    },
    methods: {
      handleScroll: lodash.debounce(function() {
        const el = this.$refs.scrollable;
        let calc =
          (el && Math.floor(el.scrollHeight - el.scrollTop - el.clientHeight)) ||
          0;

          if (el && calc <= 10 && this.searchSuggestion) {
            if (this.suggestionValues.length % this.sizeSuggestion === 0 && this.suggestionCount !== 0) {
              console.log("HIT BOTTOM SCROLL");
              this.pageSuggestion++
              this.productSearch(true);
            } 
          }
      }, 200),
      handleGetProductPagination(){
          this.getProduct();
          this.deleteItems = false;
          this.removePoductIds = []
          this.addProductIds = []
      },
      removeBadge() {
        this.urlBadge = ''
        this.selectedFiles = undefined
      },
      changeParameter(value) {

        this.payload.perPage = value.per_page;
        this.payload.currentPage = value.current_page;
        this.payload.totalItems = value.pick_items ? value.pick_items.length : 0;
        this.searchProduct = value.search
        this.sortBy = value.sort_by
        this.sortType = value.sort_type
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.deleteItems = value.delete_items
        this.pickItems = value.pick_items ? value.pick_items : []

        /**
         * kalo bisa jangan pasang getData function disini, seharusnya get / local filter hanya
         * jalan ketika sort dan ganti pagination, jika di pasang disini,
         * get / local filter juga akan ke trigger ketika tekan checkbox, bulk button, dan action lainny dri
         * value diatas
         * 
         * handle hal tersebut di watch masing2 value yg berubah
         */

      },
      async getData() {
        try{
          this.$store.dispatch("setLoadingGlobal", true)
          let payload = {
            size: 1,
            keyword: this.id,
          };
  
          const res = await this.$store.dispatch(
            "product/getAllCategoryPromo",
            payload
          );
          this.categoryPromo = res.items.length > 0 ? res.items.find(x => x.id == this.id) : {};
          this.categoryPromo.created_date = moment(
            this.categoryPromo.created_date
          ).format("DD MMM YYYY");
          this.name = this.categoryPromo.name
          this.startDate = this.filters.validateDate(this.categoryPromo.date_start);
          this.endDate = this.filters.validateDate(this.categoryPromo.date_end);
          this.badge_title = this.categoryPromo.badge_title;
          this.badge_color = this.categoryPromo.badge_background_color;
          this.urlBadge = this.categoryPromo?.badge_icon_url || "";
          this.selectedFiles = this.categoryPromo.badge_icon_url;
        }catch(err){
          console.log({err})
        }finally{
          this.$store.dispatch("setLoadingGlobal", false)
        }
      },
      async productSearch(isNext) {
        try {
          const param = {
            search: this.searchSuggestion,
            size: this.sizeSuggestion,
            page: this.pageSuggestion
          };
          let res = await this.$store.dispatch("product/productSearch", param);
          let data = res.items || []
          this.suggestionCount = res.count
          data.map((x) => {
            x.image_url = this.filters.imageParse(x.image_url);
            return x;
          });

          if(isNext){
            this.suggestionValues = [...this.suggestionValues, ...data]
          }else{
            this.suggestionValues = data
          } 
        } catch (err) {
          console.log(err);
        }
      },
      async addProduct() {
        let err = ""
        try {
          if (this.searchSuggestion == ""){
            err = "Search Input is Empty"
            this.showAlert = true
          }else if(!this.pickedSuggestions.length){
            err = "No Product Selected"
            this.showAlert = true
          }

          if(err){
            this.alertMessage = err
            setTimeout(() => {
              this.showAlert = false
            }, 1500);
            return
          }

          let arrProduct =  lodash.uniq([...this.pickedSuggestions,...this.payload.value])
          let currentIds = this.payload.value.map(x => {
            return x.id;
          });
          let productIds = arrProduct.map(x => {
            return x.id;
          });
          let filteredArr = arrProduct.filter(item=> !currentIds.includes(item.id))


          this.payload.value = [...filteredArr, ...this.payload.value]
          this.addProductIds = productIds
          this.productLocal = [...filteredArr, ...this.productLocal]

          if (this.id != "add") {
            let payload = new FormData();

            let productIds = this.payload.value.map(x => {
            return x.id;
            });
            const startDate = this.startDate != "" ? moment(this.startDate).format("YYYY-MM-DD") : "";
            const endDate = this.endDate != "" ? moment(this.endDate).format("YYYY-MM-DD") : "";

            payload.append("name", this.name);
            payload.append("display_name", "");
            payload.append("description", "");
            payload.append("slug", "");
            payload.append("date_start", startDate);
            payload.append("date_end", endDate);
            payload.append("badge_title", this.badge_title);
            payload.append("badge_background_color", this.badge_color);
            payload.append("product_ids[]", productIds);
            payload.append("icon", this.selectedFiles);
            
            payload.append("product_add_ids[]", this.addProductIds);
            payload.append("product_remove_ids[]", this.removePoductIds);
            payload.append("id", this.id);
            // console.log("ID : ",this.id)
            const body = {
              id: this.id,
              payload: payload,
            };
            await this.$store.dispatch("product/updateCategoryPromo", body);
          }
          this.pickedSuggestions = []
          this.searchSuggestion = "";
        } catch (err) {
          console.log(err);
        }
      },
      onClickHandler(e, val) {
        let parsedVal = this.payloadValueParser([val])[0]
        if(this.pickedSuggestions.find(x=> x.id == val.id)){
          this.pickedSuggestions = [...this.pickedSuggestions].filter(x=> x.id != val.id) 
        }else{
          this.pickedSuggestions = [parsedVal ,...this.pickedSuggestions]
        }
        e.target.blur();
      },
      deleteProduct(id) {
        console.log("REMOVED ID : ", id)

        this.payload.value = this.payload.value.filter((x) => {
          return x.id != id;
        });


        this.removePoductIds = lodash.uniq([id, ...this.removePoductIds]);
      },
      async submit() {
        try {
          let payload = new FormData();

          const startDate = this.startDate != "" && this.startDate ? moment(this.startDate).format("YYYY-MM-DD") : "";
          const endDate = this.endDate != "" && this.endDate ? moment(this.endDate).format("YYYY-MM-DD") : "";
          
          if (this.badge_title == ""){
            this.badgeErrorList.push("Badge Title")
          }

          if (this.badge_color == ""){
            this.badgeErrorList.push("Badge Color")
          }

          if (!this.selectedFiles){
            this.badgeErrorList.push("Badge Icon")
          }

          if (this.badgeErrorList.length > 0 && this.badgeErrorList.length < 3){
            let message = this.badgeErrorList.join(" & ")
            
            this.showAlert = true
            this.alertMessage = message+" is Empty"
            setTimeout(() => {
              this.showAlert = false
            }, 1500);
            this.badgeErrorList = []
            return
          }

          let productIds = this.payload.value.map(x => {
            return x.id;
          });

          let addProductIds = this.addProductIds.filter(item => productIds.includes(item))
          let removeProductIds = this.removePoductIds.filter(item => !productIds.includes(item))

          payload.append("name", this.name);
          payload.append("display_name", "");
          payload.append("description", "");
          payload.append("slug", "");
          payload.append("date_start", startDate);
          payload.append("date_end", endDate);
          payload.append("badge_title", this.badge_title);
          payload.append("badge_background_color", this.badge_color);
          payload.append("product_ids[]", productIds);
          payload.append("icon", this.selectedFiles);

          if (this.id != "add") {
            payload.append("product_add_ids[]", addProductIds);
            payload.append("product_remove_ids[]", removeProductIds);
            payload.append("id", this.id);
            // console.log("ID : ",this.id)
            const body = {
              id: this.id,
              payload: payload,
            };
            await this.$store.dispatch("product/updateCategoryPromo", body);
          } else {
            await this.$store.dispatch("product/createCategoryPromo", payload);
          }


          setTimeout(() => {
            this.$router.push("/products/category-promo");
          }, 1500);
        } catch (err) {
          console.log(err);
          this.$swal({
            title: err.response?.data?.errorMessage || err.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
      readURL(e) {
        const acceptFormat = ["image/png", "image/jpeg"]
        const file = e.target.files[0];
        this.showAlert = false

        if(!file) return

        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = e => {
          const src = e.target.result;
          const img = new Image();
          img.onload = () => {
            this.width = img.width
            this.height = img.height

            if (file.size > 100000) {
              this.showAlert = true
              this.alertMessage = "Size Image Too Large"

            } else if (!acceptFormat.includes(file.type)) {
              this.showAlert = true
              this.alertMessage = "Format File Not Support"

            } else if (this.width < 20 || this.height != this.width) {
              this.showAlert = true
              this.alertMessage = "Width And Height resolution less than 20x20 or ratio not 1x1"

            } else {
              this.selectedFiles = file;
              this.urlBadge = URL.createObjectURL(file);
            }
          };
          img.src = src
        }

      },
      payloadValueParser(data){
        return data.map((x, index) => {
            let status = ""
            switch (x.product_status) {
              case 'Published':
                if (x.stock_current > 0) {
                  status = "Live In Stock"
                } else {
                  status = "Live Out of Stock"
                }
                break;
              case 'Trashed':
                status = "Archive"
                break;
              case 'Suspended':
                status = 'Suspended'
                break;
              case 'NeedReview':
                status = 'Need Review'
                break;
              case 'Archive':
                status = 'Archive'
                break;
              default:
                break;
            }
            x.image_url = this.filters.imageParse(x.image_url);
            x.action = {
              id: x.id,
              index: index,
            };
            x.status = status
            return x;
          });
      },
      async getProduct() {
        let items = []
        let payloadProduct = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
          category_promo_id: this.id,
          with_trashed: "true"
        };
        if (this.searchProduct != "") {
          payloadProduct.keyword = this.searchProduct;
        }

        if (this.sortBy != "") {
            payloadProduct.sort_by = this.payload.sortBy
            payloadProduct.sort_type = this.payload.sortType
          }

        const response = await this.$store.dispatch(
          "product/getAllProduct",
          payloadProduct
        );
        if (response.items) {
          items = this.payloadValueParser(response.items)
          this.payload.totalRows = response.count;
        }
        // differentiate the ref with spread
        this.products = [...items]
        this.payload.value = [...items];
      },
      handleDeleteAll() {
        if (this.deleteItems) {
          this.pickItems.forEach(item => {
            this.deleteProduct(item)
          })
        }
      },
      handleLocalSearch(){
        if(this.searchProduct != ""){
          this.payload.value = this.productLocal.filter(x => {
            let id = x.id.toLowerCase()
            let name = x.name.toLowerCase()
            let storeName = x.seller?.store_name.toLowerCase()
            let searchValue = this.searchProduct.toLowerCase()
              return id.indexOf(searchValue) > -1 || name.indexOf(searchValue) > -1 || storeName.indexOf(searchValue) > -1
          })
        }else{
          this.payload.value = this.productLocal
        }
      },
      handleLocalSort(){
        if (this.sortBy != "" && this.sortType != 0) {
          if (this.sortType == 1) {
            this.payload.value = this.payload.value.sort((a, b) => (a[this.sortBy] > b[this.sortBy]) ? 1 : -1)
          } else {
            this.payload.value = this.payload.value.sort((a, b) => (a[this.sortBy] < b[this.sortBy]) ? 1 : -1)
          }
        }
      },
      discard() {
        if (this.id == "add") {
          this.products = []
          this.payload.value = []
          this.name = ""
          this.startDate = "";
          this.endDate = "";
          this.badge_title = ""
          this.badge_color = "";
          this.urlBadge = "";
          this.selectedFiles = undefined;
        } else {
          this.payload.value = [...this.products]
          this.removePoductIds = []
          this.addProductIds = []
          this.deleteItems = false
          // 
          this.name = this.categoryPromo.name
          this.startDate = this.filters.validateDate(this.categoryPromo.date_start);
          this.endDate = this.filters.validateDate(this.categoryPromo.date_end);
          this.badge_title = this.categoryPromo.badge_title;
          this.badge_color = this.categoryPromo.badge_background_color;
          this.urlBadge = this.categoryPromo?.badge_icon_url || "";
          this.selectedFiles = this.categoryPromo.badge_icon_url;
        }
      }
    },
    mounted() {
      if (this.id != "add") {
        this.getData();
        this.getProduct();
      }
      this.$refs.scrollable &&
      this.$refs.scrollable.addEventListener("scroll", this.handleScroll);
    },
    unmounted(){
      this.$refs.scrollable &&
      this.$refs.scrollable.removeEventListener("scroll", this.handleScroll);
    },
  };
</script>

<style scoped lang="scss">
  .file {
    opacity: 0;
    width: 0.1px;
    height: 0.1px;
    position: absolute;
  }
  .list-group{
    max-height: 300px;
    overflow: auto;
  }

  .list-group-item{
    cursor: pointer;
    &:hover{
      background-color: #F3F2F8;
    }
    &.isActive{
      background-color: #F3F2F8;
    }
  }
</style>
